import { addDays, mondayOf } from './days.js';

export { mondayOf };

/** The page window's lengths, in whole weeks. */
export type PlanWeeks = 1 | 2 | 4;
export const PLAN_WEEKS: readonly PlanWeeks[] = [1, 2, 4];

/** The window's first and last day (`YYYY-MM-DD`, both inclusive). */
export interface IWindowBounds {
  from: string;
  to: string;
}

/**
 * The Activities page's date window: `weeks` whole weeks from the Monday of
 * today's week, paged by `offsetWeeks`. It starts on Monday regardless of rest
 * days — the week is the review's unit, not the working week
 * (docs/specs/2026-09-22-work-plan-view-design.md, decision 9).
 */
export function windowBounds(today: string, weeks: PlanWeeks, offsetWeeks: number): IWindowBounds {
  const from = addDays(mondayOf(today), offsetWeeks * 7);
  return { from, to: addDays(from, weeks * 7 - 1) };
}
